export default {
  refreshYourResults: 'Rafraîchissez vos résultats',
  weNeedTo: 'Pour afficher les derniers prix et disponibilités, nous devons',
  refreshResults: 'rafraîchir vos résultats.',
  okRefresh: 'Ok, rafraîchir',
}
